<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Button } from '@/components/ui/button';
import PeekNote from '../paper/PeekNote.vue';

interface Props {
  error: Error;
}

defineProps<Props>();

const { t } = useI18n();

const handleReload = () => {
  window.location.reload();
};
</script>

<template>
  <!-- The app couldn't boot: a note with the peeking cat, and a reload. -->
  <div class="flex h-screen w-screen items-center justify-center bg-background p-4">
    <PeekNote
      class="w-full max-w-sm"
      role="alert"
    >
      <h1 class="type-app-title mb-1.5">
        {{ t('error.boot.title') }}
      </h1>
      <p class="type-caption">
        {{ t('error.boot.caption') }}
      </p>
      <Button
        class="mt-5"
        @click="handleReload"
      >
        {{ t('error.boot.retry') }}
      </Button>
    </PeekNote>
  </div>
</template>
